export class Combo {
   constructor (promotion_id, type, product_id, product_name, quantity, line_id, line_name, presentation_id, presentation_name, products_str){
      this.promotion_id = promotion_id
      this.type = type
      this.product_id = product_id
      this.product_name = product_name
      this.quantity = quantity
      this.line_id = line_id
      this.line_name = line_name
      this.presentation_id = presentation_id
      this.presentation_name = presentation_name
      this.products_str = products_str
      
      this.applicable = false
      this.applicable_quantity = 0
   }

   tipoProductoParticipante(){
      return this.type;
   }

   descripcion(){
      let s = "";
      s += this.quantity;
      if (this.type == "PRODUCTO")
      {
         s += this.product_name;
      }
      else if (this.type == "LINEA")
      {
         s += " producto(s) de la línea " + this.line_name;
      }
      else if (this.type == "LINEA_PRESENTACION")
      {
            s += " producto(s) de la línea " + this.line_name + " , presentación " + this.presentation_name;
      }
      return s;
   }
}